import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider, {Search} from 'react-bootstrap-table2-toolkit';
import paginationFactory, {PaginationProvider,} from "react-bootstrap-table2-paginator";
import {headerSortingClasses, NoRecordsFoundMessage, PleaseWaitMessage, sortCaret} from "../../../_metronic/_helpers";
import * as uiHelpers from "../baskets/BasketsUIHelpers";
import {Pagination} from "../../../_metronic/_partials/controls";
import moment from "jalali-moment";
import * as columnFormatters from "./column-formatters";
import {useHistory} from "react-router-dom";
import {AutoIncrementer} from "../../../_metronic/_helpers/AutoIncrementer";

export default function ProductsTable({
                                          data,
                                          handlePageChange,
                                          activePage
                                      }) {

    const {SearchBar} = Search;
    const history = useHistory();

    const handleEdit = (id) => {
        history.push(`/customer/products/${id}`);
    };

    // Table columns
    const columns = [
        {
            dataField: "priority",
            text: "شماره",
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
        },
        {
            dataField: "id",
            text: "شناسه محصول",
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
        },
        {
            dataField: "brandName",
            text: "برند",
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
        },
        {
            dataField: "categoryName",
            text: "دسته بندی",
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
        },
        {
            dataField: "price",
            text: "قیمت",
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
        },
        {
            dataField: "status",
            text: "وضعیت",
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
        },
        {
            dataField: "created_at",
            text: "تاریخ ایجاد",
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
            formatter: (date) => {
                if(date) {
                    const createdDate = moment(date, 'YYYY-M-D HH:mm:ss').format('jYYYY/jMM/jDD');
                    return <>{createdDate}</>;
                }
            },
        },
        {
            dataField: "action",
            text: "عملیات",
            formatter: columnFormatters.ActionsColumnFormatter,
            formatExtraData: {
                openEditPage: handleEdit,
            },
            classes: "text-right pr-0",
            headerClasses: "text-right pr-3",
            style: {
                minWidth: "100px",
            },
        },
    ];

    // Table pagination properties
    const paginationOptions = {
        custom: true,
        totalSize: data.total,
        sizePerPageList: uiHelpers.sizePerPageList,
        sizePerPage: 15,
        page: +activePage
    };

    return (
        <>
            {!!data.data &&
            <PaginationProvider pagination={paginationFactory(paginationOptions)}>
                {({paginationProps, paginationTableProps}) => {
                    return (
                        <Pagination
                            isLoading={false}
                            paginationProps={paginationProps}
                            handlePageChange={handlePageChange}
                            page={activePage}
                        >
                            <ToolkitProvider
                                keyField="priority"
                                data={AutoIncrementer(data.data, activePage - 1)}
                                columns={columns}
                                search
                            >
                                {
                                    props => (
                                        <div>
                                            <SearchBar {...props.searchProps} />
                                            <hr/>
                                            <BootstrapTable
                                                wrapperClasses="table-responsive"
                                                bordered={false}
                                                classes="table table-head-custom table-vertical-center overflow-hidden"
                                                bootstrap4
                                                defaultSorted={uiHelpers.defaultSorted}
                                                {...paginationTableProps}
                                                {...props.baseProps}
                                            >
                                                <PleaseWaitMessage entities={data.data}/>
                                                <NoRecordsFoundMessage entities={data.data}/>
                                            </BootstrapTable>
                                        </div>
                                    )
                                }
                            </ToolkitProvider>
                        </Pagination>
                    );
                }}
            </PaginationProvider>
            }

        </>
    )
}